export default function Placeholder({ label = "insert asset here", className = "", height = "h-32" }) {
  return (
    <div className={`placeholder-box ${height} ${className}`} data-testid="placeholder-box">
      [ {label} ]
    </div>
  );
}
